import React from 'react';
import { Autocomplete, FormControl, Stack, Tooltip, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';
import CustomTextField from '../forms/theme-elements/CustomTextField';
import { useAppSelector } from '../../store';
import ShowContainer from './ShowContainer';
import CusTooltip from './CusTooltip';

export default function CusAutocomplete({
  id,
  label,
  options = [],
  value,
  onChange,
  fullWidth = true,
  // toolTipTitle - устарел
  toolTipTitle = '',
  toolTipText = '',
  isRow,
  error,
  width,
  textFieldProps = {},
  multiple,
  gridSize = 12,
  disabled,
  isAlwaysOptions,
  freeSolo,
  placeholder = 'Select',
  ...props
}) {
  const { t } = useTranslation();
  const defaultInputSize = useAppSelector((state) => state.customizer.inputSize);
  const lang = useAppSelector((state) => state.site.lang);

  const isOptions = (options && options.length) || isAlwaysOptions;

  return (
    <Grid size={gridSize} width={width}>
      <FormControl fullWidth={fullWidth}>
        <Stack
          display={'flex'}
          flexDirection={isRow ? 'row' : 'column'}
          alignItems={isRow ? 'center' : undefined}
          gap={0.5}>
          <Stack gap={0.5} direction={'row'}>
            <ShowContainer condition={label}>
              <Typography color={isOptions ? 'textSecondary' : 'textDisabled'}>
                {typeof label == 'string' ? t(label) : label}
              </Typography>
            </ShowContainer>
            <ShowContainer condition={toolTipText || toolTipTitle}>
              <CusTooltip text={toolTipText || toolTipTitle} />
            </ShowContainer>
          </Stack>
          {isOptions ? (
            <Autocomplete
              freeSolo
              value={value}
              disablePortal
              options={options}
              id={id}
              name={id}
              variant="outlined"
              style={{ padding: 0 }}
              fullWidth={fullWidth}
              size={defaultInputSize}
              lang={lang}
              multiple={multiple}
              slotProps={{ popper: { sx: { padding: '0 8px' } } }}
              ListboxProps={{ style: { maxHeight: 200, overflow: 'auto' } }}
              renderInput={(inputProps) => (
                <CustomTextField
                  fullWidth={fullWidth}
                  size={defaultInputSize}
                  {...inputProps}
                  {...textFieldProps}
                  placeholder={t(placeholder)}
                />
              )}
              onChange={onChange}
              disabled={disabled}
              {...props}
            />
          ) : (
            <Typography mt={1} variant="subtitle2" color="textDisabled">
              {t('no values')}
            </Typography>
          )}
        </Stack>{' '}
        <ShowContainer condition={error}>
          <Stack mt={0.5}>
            <Typography color="error" fontWeight={900}>
              {t(error)}
            </Typography>
          </Stack>
        </ShowContainer>
      </FormControl>
    </Grid>
  );
}
